import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DestinationFilterComponent } from '../destination-filter/destination-filter.component';
import { DestinationFilter } from '../../models';
import { NgClass, NgIf } from '@angular/common';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-price-list-panel',
  imports: [DestinationFilterComponent, NgIf, NgClass],
  templateUrl: './price-list-panel.component.html',
  styleUrls: ['./price-list-panel.component.scss'],
})
export class PriceListPanelComponent {
  @Input() priceListFilters: DestinationFilter[] | undefined;
  @Input() withData = true;
  @Output() filtersChanged: EventEmitter<DestinationFilter | DestinationFilter[]> = new EventEmitter();
}
